import React, { Component } from 'react';
import { Table, Button, Card, Tag, notification, Spin, Input, Row, Col } from 'antd';
import axios from 'axios';
import moment from 'moment';
import { getErrorMsg } from "lib/fetch";
import { connect } from "react-redux";
import {
  GeneralStyledContent,
} from "../../../../styled/common-styled";
import Breadcrumb from "../../../shared/components/Breadcrumb";

const API_ENDPOINT = process.env.REACT_APP_LARAVEL_API_ENDPOINT;
const BROADCAST_TYPE = {
  "immediately": "Broadcast ทันที",
  "schedule": "Broadcast ในช่วงเวลาที่กำหนด เมื่อ Engine On",
  "continuous": "Broadcast จนกว่า Engine Off"
}

class BroadcastDeviceResponse extends Component {
  state = {
    broadcastData: null, // ข้อมูลของ broadcast (ชื่อ, ประเภท)
    deviceData: [],      // ข้อมูลของอุปกรณ์สำหรับตาราง
    loading: true,       // สถานะการโหลดข้อมูล
    error: null,         // เก็บข้อผิดพลาดหากมี
    resending: {},       // สถานะการส่งซ้ำสำหรับแต่ละรายการ (ใช้เก็บ ID ที่กำลังส่ง)
  };

  componentDidMount() {
    this.fetchData();
  }

  fetchData = async (filter = "") => {
    this.setState({ loading: true, error: null });
    let accessToken = this.props.auth.accessToken;

    if (!accessToken) {
      this.setState({
        loading: false,
        error: 'Authentication token not found. Please log in.',
      });
      notification.error({
        message: 'Authentication Error',
        description: 'Authentication token is missing. Please ensure you are logged in.',
      });
      return;
    }

    let url = window.location.pathname;
    let id = url.substring(url.lastIndexOf("/") + 1);

    const apiUrl = `${API_ENDPOINT}/broadcast-config/device-response`;

    try {
      const response = await axios.post(
        apiUrl,
        {
          config_id: id,
          filter: filter,
        },
        {
          headers: {
            Authorization: `Bearer ${accessToken}`,
            'Content-Type': 'application/json',
          },
        }
      );

      if (response.data && response.data.data) {
        const { data } = response.data;
        this.setState({
          broadcastData: data,
          deviceData: data.items || [],
          loading: false,
        });
      } else {
        this.setState({
          loading: false,
          error: 'Invalid API response format.',
        });
        notification.error({
          message: 'API Response Error',
          description: 'The data received from the API is not in the expected format.',
        });
      }
    } catch (error) {
      console.error('Error fetching data:', error);
      this.setState({
        loading: false,
        error: getErrorMsg(error),
      });
      notification.error({
        message: 'Data Fetch Failed',
        description: getErrorMsg(error),
      });
    }
  };

  // จัดการการส่งซ้ำ
  handleResend = async (record) => {
    const accessToken = this.props.auth.accessToken;

    if (!accessToken) {
      notification.error({
        message: 'Authentication Error',
        description: 'Authentication token is missing. Cannot resend.',
      });
      return;
    }

    // ตั้งค่าสถานะ resending เพื่อปิดการใช้งานปุ่มชั่วคราว
    this.setState(prevState => ({
      resending: { ...prevState.resending, [record.id]: true } // ใช้ record.id เพื่อระบุแต่ละรายการ
    }));

    const payload = {
      config_id: record.config_id.toString(),
      vehicle_id: record.vehicle_id.toString(),
    };

    try {
      const response = await axios.post(
        `${API_ENDPOINT}/broadcast-config/resend`,
        payload,
        {
          headers: {
            Authorization: `Bearer ${accessToken}`,
            'Content-Type': 'application/json',
          },
        }
      );

      if (response.data && response.data.status === 200) {
        notification.success({
          message: 'ส่งข้อมูลสำเร็จ',
          description: `ส่งข้อมูลบรอดแคสไปยังรถทะเบียน ${record.vehicle.plate_no} สำเร็จ.`,
        });
        // อาจจะต้องเรียก fetchData() อีกครั้งเพื่ออัปเดตสถานะ (ถ้า API อัปเดตข้อมูลใน DB)
        // หรืออัปเดตสถานะใน state ตรงๆ หาก Response มีข้อมูลที่ต้องการ
        this.fetchData(); // ดึงข้อมูลใหม่เพื่อสะท้อนการเปลี่ยนแปลง
      } else {
        const errorMessage = response.data.message || 'Failed to resend broadcast.';
        notification.error({
          message: 'Resend Failed',
          description: errorMessage,
        });
      }
    } catch (error) {
      console.error('Error resending broadcast:', error);
      notification.error({
        message: 'Resend Error',
        description: getErrorMsg(error),
      });
    } finally {
      // ไม่ว่าสำเร็จหรือล้มเหลว ให้ตั้งค่า resending กลับเป็น false
      this.setState(prevState => ({
        resending: { ...prevState.resending, [record.id]: false }
      }));
    }
  };

  // กำหนดคอลัมน์สำหรับตาราง
  getColumns = () => {
    return [
      {
        title: '#',
        dataIndex: 'id',
        key: 'id',
        render: (text, record, index) => index + 1, // ลำดับที่
      },
      {
        title: 'รหัสพาหนะ',
        dataIndex: 'vehicle',
        key: 'vehicle',
        render: (record) => record.code, // ลำดับที่
      },
      {
        title: 'ทะเบียน',
        dataIndex: 'vehicle',
        key: 'vehicle',
        render: (record) => record.plate_no, // ลำดับที่
      },
      {
        title: 'สถานะ',
        dataIndex: 'status',
        key: 'status',
        sorter: (a, b) => a.status - b.status,
        //sortDirections: ['descend'],
        render: (status, record) => {
          switch (status) {
            case 0:
              return <div>กำลังดำเนินการ</div>
            case 1:
              return <Tag color="green">ส่งสำเร็จ</Tag>;
            default:
              return <div>{record.response}</div>
          }
        },
      },
      {
        title: 'เวลาส่ง',
        dataIndex: 'created_at',
        key: 'created_at',
        render: (timestamp) => moment(timestamp).format('YYYY-MM-DD HH:mm:ss'),
      },
      {
        title: 'เวลารับ',
        dataIndex: 'updated_at',
        key: 'updated_at',
        render: (timestamp) => (timestamp ? moment(timestamp).format('YYYY-MM-DD HH:mm:ss') : '-'),
      },
      {
        title: 'เวลาส่งใหม่',
        dataIndex: 'resend_at',
        key: 'resend_at',
        render: (timestamp) => (timestamp ? moment(timestamp).format('YYYY-MM-DD HH:mm:ss') : '-'),
      },
      {
        title: 'ดำเนินการ',
        key: 'action',
        render: (text, record) => {
          return <Button
            type="primary"
            onClick={() => this.handleResend(record)}
            loading={this.state.resending[record.id]} // แสดงสถานะ loading บนปุ่ม
            disabled={this.state.resending[record.id] || this.state.broadcastData.is_active === 0} // ปิดการใช้งานปุ่มขณะส่ง
          >
            ส่งซ้ำ
          </Button>
        },
      },
    ];
  };

  getBroadcastDetail = () => {
    let broadcastData = this.state.broadcastData
    let data = JSON.parse(broadcastData.config_json)
    switch (broadcastData.broadcast_type) {
      case "immediately":
        return <div style={{ marginTop: "10px" }}>
          <p>แจ้งเตือน (ครั้ง): {data.AlarmTime}</p>
          <p>ระยะห่างที่แจ้งเตือน (วินาที): {data.IntervalTime}</p>
        </div>
      case "schedule":
        return <div style={{ marginTop: "10px" }}>
          <p>แจ้งเตือน (ครั้ง): {data.AlarmTime}</p>
          <p>ระยะห่างที่แจ้งเตือน (วินาที): {data.IntervalTime}</p>
          <p>เวลาเริ่ม-สิ้นสุด: {data.ScheduleStart} - {data.ScheduleEnd}</p>
        </div>
      case "continuous":
        return <div style={{ marginTop: "10px" }}>
          <p>ระยะห่างที่แจ้งเตือน (วินาที): {data.IntervalTime}</p>
        </div>
      default:
        break;
    }
  }

  render() {
    const { broadcastData, deviceData, loading } = this.state;

    return (
      <GeneralStyledContent>
        <Spin spinning={loading}>
          <Row gutter={24}>
            <Col span={24}>
              <Breadcrumb
                match={this.props.match}
                style={{ margin: "0px 0px 14px 10px" }}
              />
            </Col>
          </Row>
          <Row>
            {/* ส่วนที่แสดงข้อมูล Broadcast */}
            {broadcastData && (
              <Card title="รายละเอียด" style={{ marginBottom: 20 }}>
                <p><strong>ชื่อ Broadcast:</strong> {broadcastData.name || 'N/A'}</p>
                <p><strong>ประเภท Broadcast:</strong> {BROADCAST_TYPE[broadcastData.broadcast_type] || 'N/A'}</p>
                <p><strong>รายละเอียด:</strong>{this.getBroadcastDetail()}</p>
                {/* สามารถเพิ่มข้อมูลอื่น ๆ ของ broadcastData ได้ที่นี่ */}
              </Card>
            )}

            {/* ส่วนที่แสดงตารางข้อมูลอุปกรณ์ */}
            <Card title="ประวัติการส่งบรอดแคส">
              <Row gutter={[24, 24]} type="flex" justify="end">
                <Col span={6} style={{ margin: 20 }}>
                  <Input.Search placeholder="ค้นหาตามรหัสหรือทะเบียน..."
                    onSearch={value => this.fetchData(value)} enterButton />
                </Col>
              </Row>
              <Row gutter={[12, 12]}>
                <Col span={24}>
                  <Table
                    columns={this.getColumns()}
                    dataSource={deviceData}
                    rowKey="id" // ใช้ id ของแต่ละรายการเป็น key ที่ไม่ซ้ำกัน
                    pagination={{ pageSize: 10 }} // สามารถกำหนด pagination ได้
                  />
                </Col>
              </Row>
            </Card>
          </Row>
        </Spin>
      </GeneralStyledContent>
    );
  }
}

export default connect(
  ({ auth }) => ({ auth }),
  {}
)(BroadcastDeviceResponse);
